import SelfServiceEntityTableHeader from "./SelfServiceEntityTableHeader";

export default SelfServiceEntityTableHeader;
